import React, { ReactNode, type ComponentProps, forwardRef } from "react";
import "./checkbox.css";

type CheckboxType = Omit<ComponentProps<"input">, "size"> & {
  label?: string | ReactNode;
  labelClassName?: string;
  id?: string;
  containerClassName?: string;
  icon?: ReactNode;
  checkedIcon?: ReactNode;
  labelPosition?: "top" | "right" | "bottom" | "left";
  size?: "small" | "medium" | "large" | "extraLarge";
};

const Checkbox = forwardRef<HTMLInputElement, CheckboxType>(
  (
    {
      label,
      id,
      containerClassName = "",
      labelClassName = "",
      labelPosition = "left",
      icon,
      checkedIcon,
      checked,
      size = "medium",
      ...props
    },
    ref
  ) => {
    return (
      <div
        className={`taptap-checkbox-container | gap-4 ${labelPosition}  ${containerClassName} taptap-checkbox-size-${size}`}
      >
        {label ? (
          typeof label === "string" ? (
            <label
              htmlFor={`taptap-custom-checkbox-input-${id}`}
              className={` | m-0 fw-500 user-select-none pointer ${labelClassName}`}
            >
              {label}
            </label>
          ) : (
            label
          )
        ) : null}
        {!checked && icon && (
          <span className="taptap-checkbox-icon">{icon}</span>
        )}
        {checkedIcon && checked && (
          <span className="taptap-checkbox-checked-icon">{checkedIcon}</span>
        )}
        <input
          ref={ref}
          checked={checked}
          type="checkbox"
          className="taptap-custom-checkbox-input pointer"
          id={`taptap-custom-checkbox-input-${id}`}
          {...props}
        />
      </div>
    );
  }
);

Checkbox.displayName = "Checkbox";

export default Checkbox;
